import { matchRoutes, useLocation } from "react-router-dom";
import { adminPaths, userPaths, patientPaths, systemAdminPaths } from "../navigation";

const usePathPattern = () => {
  const location = useLocation();

  const matchers = [{ paths: userPaths }, { paths: adminPaths }, { paths: patientPaths }, { paths: systemAdminPaths }];

  const match = matchers.map(({ paths }) => matchRoutes(paths, location)).find(route => route !== null);
  const path = match?.[0]?.route?.path;
  return { path };
};

export default usePathPattern;
